import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnDestroy,
  Renderer2,
  inject,
} from '@angular/core';
import { TooltipOverlay } from './tooltip-overlay';

@Directive({
  selector: '[appTooltip]',
  standalone: true,
})
export class TooltipDirective implements OnDestroy {
  @Input('appTooltip') tooltipText = '';
  @Input() tooltipPlacement: string | string[] = 'auto';
  @Input() tooltipOnlyWhenOverflow = false;

  private readonly elementRef = inject(ElementRef);
  private readonly renderer = inject(Renderer2);
  private readonly overlay = new TooltipOverlay(
    this.renderer,
    this.elementRef.nativeElement,
  );

  @HostListener('mouseenter')
  onMouseEnter(): void {
    if (this.tooltipOnlyWhenOverflow && !this.isHostOverflowing()) {
      return;
    }

    this.overlay.show(this.tooltipText, this.tooltipPlacement);
  }

  @HostListener('mouseleave')
  onMouseLeave(): void {
    this.overlay.hide();
  }

  @HostListener('focusin')
  onFocusIn(): void {
    if (this.tooltipOnlyWhenOverflow && !this.isHostOverflowing()) {
      return;
    }

    this.overlay.show(this.tooltipText, this.tooltipPlacement);
  }

  @HostListener('focusout')
  onFocusOut(): void {
    this.overlay.hide();
  }

  ngOnDestroy(): void {
    this.overlay.hide();
  }

  private isHostOverflowing(): boolean {
    const host = this.elementRef.nativeElement as HTMLElement;

    const horizontalOverflow = host.scrollWidth - host.clientWidth > 0;
    const verticalOverflow = host.scrollHeight - host.clientHeight > 0;

    return horizontalOverflow || verticalOverflow;
  }
}
